// 鶏 (inverted-jester) の鬨ずらしの時間 (2026-10-30 作り直し)。
//   作者 R-1「なきやんでから攻撃開始するまでが早すぎて反応できない」「鳴き声によって弾くリズムが異なる感じにしたほうが良い」。
//
//   鳴き止みから1発目の当たりまで TOKI_CUT_TO_HIT_MS。前は約 200ms で、目で見た合図への反応 (200〜250ms) に
//   画面と入力の遅れを足すと間に合わなかった。弾きの受付は当たりの 200ms 前から開く (balance.ts parryActiveMs) ので、
//   鳴き止みから 250〜450ms の間に押せば弾ける。
//
//   鳴き声の形 = 爪の拍。鳴きを聞けば、どの間で弾くかが先に分かる。
//     短い鳴き「コッ・コッ・コッ」= 声と声の間 450ms → 爪も 450ms おきの3連「タ・タ・タ」。
//     長い鳴き「コケコッコーー」= 伸ばして止む → 爪は「タ……タタ」(1発目のあと 890ms ため、残り2発は 450ms で詰める)。
//   爪の間 (comboGap) は 320ms を割らない (attacks.ts「公平性の床」＝弾き直しの最短サイクル)。発と発の間隔 = 当たり 130 + 間。
//   加速 (src/rooster_rush.ts) は戻りと待機だけを詰め、溜めと爪の間は詰めない。鳴きと爪の拍がずれず、床 320 も割らない。
// 記録 docs/research/2026-10-30-rooster-toki-rhythm.md

/** 鳴き止みから1発目の当たりまで (ms)。 */
export const TOKI_CUT_TO_HIT_MS = 450

/** 短い鳴きの「コッ」1声の長さと、声の始まりの時刻 (溜めの頭から・ms)。 */
export const TOKI_SHORT_CLUCK_MS = 150
export const TOKI_SHORT_CLUCK_AT_MS = [0, 450, 900] as const
/** 短い鳴きが止む時刻 = 最後の声の終わり。 */
export const TOKI_SHORT_CUT_MS = TOKI_SHORT_CLUCK_AT_MS[2] + TOKI_SHORT_CLUCK_MS
export const TOKI_SHORT_CHARGE_MS = TOKI_SHORT_CUT_MS + TOKI_CUT_TO_HIT_MS
/** 爪の間 (当たりの終わり → 次の当たり)。間隔 130+320 = 450 で、声の間とそろえる。 */
export const TOKI_SHORT_GAP_MS = 320

/** 長い鳴きが止む時刻 (溜めの頭から・ms)。 */
export const TOKI_LONG_CUT_MS = 1250
export const TOKI_LONG_CHARGE_MS = TOKI_LONG_CUT_MS + TOKI_CUT_TO_HIT_MS
/** 爪の間「タ……タタ」。間隔 890 → 450。 */
export const TOKI_LONG_GAPS_MS = [760, 320] as const
